import { withLoginUser } from 'src/api/user'
import { GuestPageWrapper, MemberPageWrapper } from 'src/components/PageWrapper'
import { BASE_PATH, CONTENTS } from 'src/utils/routes'
import { ContentSearchPageLayout } from './ContentSearchPageLayout'

export const ContentSearch = withLoginUser(({ user, loggedIn }) => {
  return (
    <>
      {loggedIn ? (
        <MemberPageWrapper
          user={user}
          currentPath="検索結果"
          parentPaths={[
            { label: '経営コラム', path: `${BASE_PATH}${CONTENTS}` },
          ]}
        >
          <ContentSearchPageLayout />
        </MemberPageWrapper>
      ) : (
        <GuestPageWrapper>
          <ContentSearchPageLayout />
        </GuestPageWrapper>
      )}
    </>
  )
})
